/**
 * 未退勤・不整合について「**何を出すか**」だけを決める（R0102 A-3）。
 *
 * ★`src/ui/wage-alert-view.ts` と同じ理由で DOM から切り離す。**判断をここだけに置く**——
 *   描画側（`main.ts`）は配列を DOM へ写すだけにし、出す／出さないをここで決める
 *   （`.loop/memory.md`「判定を各所に書くと、書き忘れた場所が『制限なし』になる」）。
 *
 * ★氏名・時給は扱わない（絶対ルール1）。`staffId` は生の数値のまま出す
 *   （氏名との対応は `src/ui/main.ts` 側で従業員一覧と突き合わせる）。
 */
import type { AttendanceAnomaly } from "./api.js";

/**
 * 画面に出す行。**0件なら空配列**（沈黙ではなく「該当なし」を明示したい場合は
 * 呼び出し側が別途 `passed` 相当の文言を出すこと。ここは異常があるときだけ返す
 * ——`.loop/memory.md`「判定を返せると誰かの目に触れるは別」。件数を必ず含める）。
 */
export function attendanceAnomalyLines(anomalies: readonly AttendanceAnomaly[]): string[] {
  if (anomalies.length === 0) return [];
  return anomalies.map((a) => `${a.businessDate}（従業員 ${a.staffId}）：${a.reason}`);
}

/** 見出し。**件数を書く**（`.loop/memory.md`「N件すべて緑」を受け取る前に件数を分けて聞く） */
export function attendanceAnomalyHeading(anomalies: readonly AttendanceAnomaly[]): string {
  return `未退勤・不整合：${anomalies.length}件`;
}
